import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Stadtwerke Bochum ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sind Sie ein Mitarbeiter der Covivio dann klicken Sie auf Weiter. Sollten Sie kein Mitarbeiter der Covivio sein, so wählen Sie bitte Kein Mitarbeiter. ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Bitte geben Sie hier Ihren Code ein: ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Kein Mitarbeiter ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Weiter ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_IoText = _resolveComponent("IoText")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_BaseGridCol = _resolveComponent("BaseGridCol")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    closeable: false,
    loading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_IoHeadline, {
        "tag-name": "h5",
        size: "h2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_ctx.partner.title) + " in Kooperation mit", 1),
            _hoisted_1,
            _hoisted_2
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      _createVNode(_component_IoText, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      _createVNode(_component_BaseGridRow, { center: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseGridCol, { s: { xs: 12, xl: 6 } }, {
            default: _withCtx(() => [
              _createVNode(_component_InputField, {
                label: "Code",
                type: "text",
                modelValue: _ctx.form.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.code) = $event)),
                error: _ctx.errors.value.code,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors.value.code = null))
              }, null, 8, ["modelValue", "error"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      _createVNode(_component_BaseGridRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_BaseGridCol, { s: { xs: 12, xl: 'auto' } }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                color: "dark",
                type: "outline",
                "color-hover": "dark",
                "type-hover": "default",
                rounded: "1",
                "link-type": "button",
                onClick: _ctx.redirectToHome
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_BaseGridCol),
          _createVNode(_component_BaseGridCol, { s: { xs: 12, xl: 'auto' } }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                rounded: "1",
                type: "default",
                color: "primary",
                "link-type": "button",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading"]))
}